export type AgencyPortalModel = {
  agency_id: number,
  agency_title: string,
  authentication_token?: string,
  cache_key: number,
  id: number,
  identity_code: string,
  force_xml_agency?: boolean,
  portal_id: number,
}

export type AgencyPortalRequestOptions = {}

const state = {
  agency_id: undefined,
  authentication_token: '',
  id: null,
  identity_code: '',
  options: {
    force_xml_agency: false,
  },
  portal_id: undefined,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'identity_code' },
  { key: 'portal_id' },
]

export default state
